<h1 class="obg-sm-terms-and-conditions-message-title" [innerHTML]="data?.title"></h1>
<div class="obg-sm-terms-and-conditions-message-content">
	<div class="obg-sm-terms-and-conditions-message-text">
		<div [innerHTML]="data?.message"></div>
		<div
			*ngIf="data?.summary"
			class="obg-sm-terms-and-conditions-message-summary"
			[innerHTML]="data?.summary"
		></div>
	</div>
	<button
		*ngIf="data?.isExtendedUi"
		mat-button
		color="primary"
		class="obg-sm-terms-and-conditions-message-read-more"
		test-id="alert-button-read-more"
		(click)="onReadMore()"
	>
		{{ 'terms-and-conditions.updated-read' | translate }}
	</button>
</div>
